import {ColDef, ColType} from "../interfaces/colDef";
import {UserStatus} from "../interfaces/user";

export const locationItem: ColDef = {
  name: 'location_home',
  title: 'location',
  sort: true,
  required: false,
  type: ColType.LOCATION
};

export const stickyColumns: ColDef[] = [{
  name: 'name',
  sort: true,
  type: ColType.STRING,
  required: true,
  disabled: true,
  title: 'name'
}];

export const otherDefs: ColDef[] = [
  {
    title: 'status',
    name: 'status',
    type: ColType.RADIO,
    required: true,
    list: [
      {
        id: UserStatus.ACTIVE,
        name: 'Active'
      },
      {
        id: UserStatus.PENDING,
        name: 'Pending'
      },
      {
        id: UserStatus.ARCHIVED,
        name: 'Archived'
      }
    ]
  }
];

export const invitedStickyColumns: ColDef[] = [
  {
    name: 'username',
    title: 'email',
    type: ColType.STRING,
    required: true,
    disabled: true,
  }
];

export const scheduleStickyColumns: ColDef[] = [{
  name: 'name',
  sort: false,
  filter: false,
  type: ColType.STRING,
  required: true,
  disabled: true,
  title: 'name'
}];

export const scheduleColumns: ColDef[] = [
  {
    name: 'percent_filled',
    title: 'scheduled',
    subtitle: 'explain.user.averagescheduled',
    required: false,
    type: ColType.INT,
    filter: false,
    sort: true
  },
  {
    name: 'scheduled',
    title: 'scheduledhours',
    subtitle: 'explain.user.scheduledhours',
    required: false,
    type: ColType.INT,
    filter: false,
    sort: true
  },
  {
    name: 'delta_hours',
    title: 'availablehours',
    subtitle: 'explain.user.availablehours',
    required: false,
    type: ColType.INT,
    filter: false,
    sort: true
  },
  {
    name: 'fte',
    title: 'fte',
    subtitle: 'explain.user.fte',
    required: false,
    type: ColType.INT,
    filter: false,
    sort: true,
    range: {
      lte: 1.0,
      gte: 0.0
    }
  },
  {
    name: 'offered',
    title: 'offeredtotal',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'cost',
    title: 'cost',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'value',
    title: 'forcastvalue',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'margin',
    title: 'forcastmargin',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'num_projects',
    title: 'totalprojects',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'capacity',
    title: 'sumhours',
    subtitle: 'explain.user.totalhours',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT,
    range: {
      lte: 10000,
      gte: 0
    }
  },
  {
    name: 'duration',
    title: 'tracking.trackedtime',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CUSTOM
  },
  {
    name: 'tracked_amount',
    title: 'tracking.tracked_amount',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'tracked_scheduled',
    title: 'tracking.tracked_scheduled',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'tracked_budget',
    title: 'tracking.tracked_budget',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  // {
  //   name: 'tracked_value',
  //   title: 'tracking.tracked_value',
  //   required: false,
  //   filter: false,
  //   sort: true,
  //   type: ColType.INT
  // },
  // {
  //   name: 'tracked_margin',
  //   title: 'tracking.tracked_margin',
  //   required: false,
  //   filter: false,
  //   sort: true,
  //   type: ColType.INT
  // },
  {
    name: 'status',
    title: 'currentstatus',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'max_score',
    title: 'score',
    required: false,
    sort: true,
    filter: false,
    type: ColType.INT,
    noexport: true
  }
];

export const appliedStickyColumns: ColDef[] = [
  {
    name: 'name',
    type: ColType.STRING,
    title: 'name',
    required: true,
    disabled: true,
    filter: true,
    sort: true
  }
];

export const appliedColumns: ColDef[] = [
  {
    name: 'username',
    type: ColType.STRING,
    title: 'email',
    required: true,
    disabled: true,
    filter: true,
    sort: true
  },
  {
    name: 'created_at',
    type: ColType.DATE,
    title: 'applied_at',
    required: false,
    filter: false,
    sort: true
  },
  {
    name: 'user_created_at',
    type: ColType.DATE,
    title: 'created_at',
    required: false,
    filter: false,
    sort: true
  },
  {
    name: 'phone',
    subtitle: 'explain.user.phone',
    title: 'phone',
    required: false,
    sort: true,
    filter: false,
    type: ColType.PHONE
  },
  {
    name: 'location_home',
    title: 'location',
    sort: true,
    filter: false,
    required: false,
    type: ColType.LOCATION
  },
  {
    name: 'approve_reject',
    title: 'approve_reject',
    required: true,
    disabled: true,
    type: ColType.CUSTOM,
    filter: false,
    sort: false
  }
];

export const invitedColumns: ColDef[] = [
  {
    name: 'invited_at',
    type: ColType.DATE,
    title: 'invited_at',
    required: true,
    disabled: true,
    filter: false,
    sort: true
  },
  {
    name: 'invites',
    type: ColType.INT,
    title: 'invites',
    required: false,
    filter: false,
    sort: true
  },
  {
    name: 'created_at',
    type: ColType.DATE,
    title: 'created_at',
    required: false,
    filter: false,
    sort: true
  },
  {
    name: 'created_by',
    type: ColType.STRING,
    title: 'created_by',
    required: false,
    filter: false,
    sort: false
  },
  {
    name: 'last_opened',
    title: 'last_opened',
    type: ColType.DATE,
    required: false,
    filter: false,
    sort: true
  },
  {
    name: 'last_clicked',
    title: 'last_clicked',
    type: ColType.DATE,
    required: false,
    filter: false,
    sort: true
  },
  {
    name: 'send_invite',
    title: 'reinvite',
    type: ColType.CUSTOM,
    required: true,
    disabled: true,
    filter: false,
    sort: false
  },
  {
    name: 'revoke_invite',
    title: 'revokeinvite',
    type: ColType.CUSTOM,
    required: true,
    disabled: true,
    filter: false,
    sort: false
  }
];

export const columns: ColDef[] = [
  {
    name: 'username',
    subtitle: 'explain.user.username',
    type: ColType.STRING,
    title: 'username',
    required: true,
    disabled: true
  },
  {
    name: 'start_on',
    subtitle: 'explain.user.start_on',
    title: 'startdate',
    required: false,
    type: ColType.DATE
  },
  {
    name: 'end_on',
    subtitle: 'explain.user.end_on',
    title: 'enddate',
    required: false,
    type: ColType.DATE
  },
  {
    name: 'phone',
    subtitle: 'explain.user.phone',
    title: 'phone',
    required: false,
    type: ColType.PHONE
  },
  locationItem,
  {
    name: 'role',
    title: 'userrole',
    subtitle: 'explain.user.role',
    required: true,
    disabled: true,
    type: ColType.SELECT,
    list: [
      {
        id: null,
        name: 'Any'
      },
      {
        name: 'User',
        id: 1
      },
      {
        name: 'Staffer',
        id: 2
      },
      {
        name: 'Admin',
        id: 3
      }
    ]
  },
  {
    name: 'seniority',
    title: 'seniority',
    subtitle: 'explain.user.seniority',
    sort: ['seniority'],
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'department',
    title: 'department',
    subtitle: 'explain.user.department',
    sort: ['department'],
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'parent_id',
    title: 'focalcontact',
    subtitle: 'explain.user.focalcontact',
    sort: true,
    filter: 'member',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'freelancer',
    subtitle: 'explain.user.freelancer',
    title: 'freelancer',
    required: false,
    type: ColType.RADIO,
    list: [
      {
        id: null,
        name: 'Any'
      },
      {
        id: 0,
        name: 'Internal'
      },
      {
        id: 1,
        name: 'External'
      }
    ]
  },
  {
    name: 'offered',
    title: 'offeredhourly',
    subtitle: 'explain.user.offered',
    required: false,
    type: ColType.CURRENCY,
    range: {
      lte: 1000,
      gte: 0
    }
  },
  {
    name: 'cost',
    title: 'costhourly',
    subtitle: 'explain.user.cost',
    required: false,
    type: ColType.CURRENCY,
    range: {
      lte: 1000,
      gte: 0
    }
  },
  {
    name: 'capacity',
    title: 'capacity',
    subtitle: 'explain.user.workingdays',
    required: true,
    disabled: true,
    type: ColType.SLIDER,
    filter: false,
    sort: false,
    range: {
      lte: 168,
      gte: 0
    }
  },
  {
    name: 'cv',
    title: 'cv',
    subtitle: 'explain.user.cv',
    required: false,
    type: ColType.AREA,
    filter: false,
    sort: false
  },
  {
    name: 'project',
    title: 'projects',
    subtitle: 'explain.user.projects',
    sort: ['project'],
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'industry',
    title: 'userindustries',
    subtitle: 'explain.user.industries',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'domain',
    title: 'userdomains',
    subtitle: 'explain.user.domains',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'category',
    title: 'usercategories',
    subtitle: 'explain.user.skills',
    required: false,
    filter: false,
    type: ColType.LISTADDER
  },
  {
    name: 'skill',
    title: 'userskills',
    subtitle: 'explain.user.hardskills',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'certification',
    title: 'usercertifications',
    subtitle: 'explain.user.certifications',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'development',
    title: 'userdevelopments',
    subtitle: 'explain.user.softskills',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'language',
    title: 'userlanguages',
    subtitle: 'explain.user.languages',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'degree',
    title: 'userdegrees',
    subtitle: 'explain.user.qualifications',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'market',
    title: 'usermarkets',
    subtitle: 'explain.user.markets',
    required: false,
    type: ColType.LISTADDER
  },
  {
    name: 'leave',
    title: 'leave',
    subtitle: 'explain.user.leave',
    required: false,
    type: ColType.RANGE
  },
  {
    name: 'birthdate',
    title: 'birthdate',
    subtitle: 'explain.user.birthdate',
    required: false,
    type: ColType.DATE
  }
];
